import { render, staticRenderFns } from "./OutdatedBrowser.vue?vue&type=template&id=4297b851&scoped=true&"
var script = {}
import style0 from "./OutdatedBrowser.vue?vue&type=style&index=0&id=4297b851&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.registry.npmjs.org/vue-loader/15.9.8_css-loader@3.6.0+webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4297b851",
  null
  
)

export default component.exports